const nominowChartDefaults = require('./nominow-chart-defaults.js');

(function () {
	Vue.component('nominow-chart-scatterplot', {
		mixins: [nominowChartDefaults.mixin],
		template: `<div :id="id"></div>`,
		props: {
			chartData: {
				type: Object,
				required: true
			}
		},
		data: function () {
			return {
				id: 'nnchartscatterplot-' + new Date().getTime(),
				chart: null
			}
		},
		created: function () {
			console.log('scatterplot component');
			Vue.nextTick(() => {
				this.setupChart();
			});
		},
		methods: {
			setupChart: function () {
				const chartData = this.chartData;
				const colors = window.getChartColors(2);
				const axis = {
					x: 'Pct',
					y: 'Ratio'
				};
				const data = [];

				for (let i = 0; i < chartData.Factors.length; i++) {
					const factor = chartData.Factors[i];
					const percentage = factor['Group pct.'] || 0;
					const ratio = factor['Group Total ratio'] || 0;
					data.push({
						name: factor['Factor'],
						data: [[percentage, ratio]],
						color: ratio > 1 ? colors[1] : colors[0],
						marker: {
							symbol: ratio > 1 ? 'circle' : 'square'
						}
					})
				}

				vuelog('scatter', data);
				this.chart = Highcharts.chart(this.id, $.extend(true, {}, this.chartDefaults(), {
					chart: {
						type: 'scatter',
						zoomType: 'xy'
					},
					tooltip: {
						formatter: null
					},
					yAxis: {
						title: {
							text: axis.y,
							style: {
								color: globalColors.primary.hue9
							}
						},
						showFirstLabel: false,
						showLastLabel: false,
						labels: {
							style: {
								color: globalColors.primary.hue9
							}
						},
						lineColor: globalColors.primary.hue1,
						gridLineColor: globalColors.primary.hue1,
						lineWidth: 1,
						tickWidth: 1,
						tickColor: globalColors.primary.hue1
					},
					xAxis: {
						title: {
							text: axis.x,
							style: {
								color: globalColors.primary.hue9
							}
						},
						labels: {
							style: {
								color: globalColors.primary.hue9
							}
						},
						lineColor: globalColors.primary.hue1,
						gridLineColor: globalColors.primary.hue1,
						tickWidth: 0
					},
					plotOptions: {
						scatter: {
							marker: {
								radius: 5,
								states: {
									hover: {
										enabled: true,
										lineColor: 'rgb(100,100,100)'
									}
								}
							},
							states: {
								hover: {
									marker: {
										enabled: false
									}
								}
							},
							tooltip: {
								enabled: true,
								outside: true,
								backgroundColor: globalColors.primary.hue9,
								headerFormat: '<b>{series.name}</b><br>',
								pointFormat: `${axis.x}: {point.x}<br/>${axis.y}: {point.y}`
							}
						}
					},
					series: data,
				}));
				this.$emit('chartReady', this.chart);
			}
		}
	})
})();
